import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="admin-yu-baby-message"
export default class extends Controller {
  static targets = ['collapsedText']

  collapse(e) {
    e.preventDefault()
    this.collapsedTextTargets.forEach((collapsedText) => {
      collapsedText.classList.remove('line-clamp-5')
      collapsedText.classList.remove('white-space-unset')
      collapsedText.classList.add('white-space-pre-wrap')
    })
    e.target.remove()
  }
}
